import styles from './CategoryPill.module.css';

interface CategoryPillProps {
  icon: string;
  label: string;
  selected?: boolean;
  onClick?: () => void;
}

export function CategoryPill({icon, label, selected = false, onClick}: CategoryPillProps) {
  return (
    <button
      className={[styles.pill, selected ? styles.selected : ''].filter(Boolean).join(' ')}
      onClick={onClick}
    >
      <span>{icon}</span>
      {label}
    </button>
  );
}
